import Vue from 'vue'
import App from './App.vue'
import router from './router';

import {
  Layout,
  Button,
  Spin,
  Result,
  Card,
  Divider,
  Col,
  Row,
  Drawer,
  Table,
  Form,
  InputNumber,
  Tag,
  Dropdown,
  Menu,
  Select,
  Icon,
  Steps, Input, Checkbox, DatePicker, Modal, Radio, Upload, List, Pagination
} from 'ant-design-vue';

import 'ant-design-vue/dist/antd.css';
import i18n from './i18n';

import "./assets/scss/main.scss";
import * as VueGoogleMaps from 'vue2-google-maps';
import {GAPI_KEY} from "./script/helper"

import VueHtml2pdf from 'vue-html2pdf'

Vue.config.productionTip = false

Vue.use(Layout);
Vue.use(Button);
Vue.use(Spin);
Vue.use(Result);
Vue.use(Card);
Vue.use(Divider);
Vue.use(Col);
Vue.use(Row);
Vue.use(Drawer);
Vue.use(Table);
Vue.use(Form);
Vue.use(InputNumber);
Vue.use(Tag);
Vue.use(Dropdown);
Vue.use(Menu)
Vue.use(Select);
Vue.use(Icon);
Vue.use(Steps);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(DatePicker);
Vue.use(Modal);
Vue.use(Radio);
Vue.use(Upload);
Vue.use(List);
Vue.use(Pagination)

Vue.use(VueHtml2pdf)

Vue.use(VueGoogleMaps, {
  load: {
    key: GAPI_KEY(),
    libraries: 'places',
  }
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
